import React from 'react';
import { useApp } from '../../context/AppContext';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { HOME_KPIS, HOME_FEED, HOME_ACTIONS, HOME_ACTIVE_PLAYBOOKS } from '../../constants';

export default function HomeScreen() {
  const { currentUser, go, setActivePbIdx } = useApp();
  const { isMobile, isTablet, rp } = useBreakpoint();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning ☀️' : hour < 17 ? 'Good afternoon 👋' : 'Good evening 🌙';
  const px = rp({ mobile: '14px', tablet: '20px', desktop: '28px' });

  return (
    <div style={{ flex: 1, overflowY: 'auto', height: '100%' }}>
      {/* Header */}
      <div style={{ padding: `${rp({ mobile: '16px', desktop: '22px' })} ${px} 0`, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px', flexShrink: 0, flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: rp({ mobile: '18px', desktop: '22px' }), fontWeight: '800', color: 'var(--navy)', fontFamily: "'DM Serif Display', serif" }}>{greeting}</div>
          <div style={{ fontSize: '12px', color: 'var(--text3)', marginTop: '3px' }}>
            {isMobile ? `Hi, ${currentUser?.name?.split(' ')[0]}` : `Here's what needs your attention today, ${currentUser?.name?.split(' ')[0]}`}
          </div>
        </div>
        {!isMobile && (
          <button onClick={() => { setActivePbIdx(0); go('client'); }}
            style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '8px 14px', borderRadius: '9px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0 }}>
            <i className="ti ti-eye" style={{ fontSize: '14px', color: '#C8973A' }} />
            Preview buyer view
          </button>
        )}
      </div>

      <div style={{ padding: `16px ${px}` }}>
        {/* KPI Strip — 4 cols desktop, 2x2 tablet/mobile */}
        <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr 1fr', desktop: 'repeat(4,1fr)' }), gap: '10px', marginBottom: '16px' }}>
          {HOME_KPIS.map((kpi, i) => (
            <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: rp({ mobile: '12px', desktop: '14px 16px' }) }}>
              <div style={{ fontSize: '10px', fontWeight: '600', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: '5px' }}>{kpi.label}</div>
              <div style={{ fontSize: rp({ mobile: '24px', desktop: '28px' }), fontWeight: '800', color: kpi.valueColor || 'var(--navy)', lineHeight: 1 }}>{kpi.value}</div>
              <div style={{ fontSize: '10px', color: kpi.changeColor, marginTop: '3px', fontWeight: '600' }}>{kpi.change}</div>
            </div>
          ))}
        </div>

        {/* Live activity + Actions — 2 cols on desktop, stacked on small */}
        <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr', desktop: '1fr 1fr' }), gap: '14px', marginBottom: '16px' }}>
          {/* Live activity feed */}
          <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', display: 'flex', alignItems: 'center', gap: '7px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block', boxShadow: '0 0 0 3px #22C55E30' }} />
                Live activity
              </div>
              <span style={{ fontSize: '10px', color: 'var(--text3)' }}>Last 24h</span>
            </div>
            <div>
              {HOME_FEED.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 14px', borderBottom: i < HOME_FEED.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: item.bg, color: item.color, fontSize: '10px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>{item.ini}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--navy)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.name} <span style={{ fontWeight: '400', color: 'var(--text3)' }}>{item.action}</span></div>
                    <div style={{ fontSize: '10px', color: 'var(--text3)', marginTop: '2px' }}>{item.org} · {item.time}</div>
                    <div style={{ marginTop: '5px', display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '2px 7px', background: item.badgeBg, borderRadius: '20px', fontSize: '9px', fontWeight: '700', color: item.badgeColor }}>{item.badge}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Actions queue */}
          <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>⚡ Actions for you</div>
              <span style={{ fontSize: '10px', padding: '2px 8px', background: '#FEF2F2', color: '#EF4444', borderRadius: '20px', fontWeight: '700' }}>3 pending</span>
            </div>
            <div>
              {HOME_ACTIONS.map((action, i) => (
                <div key={i} style={{ padding: '10px 14px', borderBottom: i < HOME_ACTIONS.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '5px' }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: action.color, flexShrink: 0 }} />
                    <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--navy)' }}>{action.title}</div>
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text3)', marginBottom: '8px', paddingLeft: '14px' }}>{action.desc}</div>
                  <div style={{ paddingLeft: '14px', display: 'flex', gap: '6px' }}>
                    <button onClick={() => go('tracking')} style={{ padding: '5px 11px', borderRadius: '6px', background: 'var(--navy)', border: 'none', color: 'white', fontSize: '11px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <i className="ti ti-send" /> Nudge
                    </button>
                    <button onClick={() => go('analytics')} style={{ padding: '5px 10px', borderRadius: '6px', border: '1.5px solid var(--border2)', background: 'white', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', fontFamily: 'inherit' }}>Signals</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Active Playbooks — 3 cols desktop, 1 col mobile */}
        <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>Active Playbooks</div>
            <button onClick={() => go('admin')} style={{ fontSize: '11px', color: 'var(--gold)', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>View all →</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', tablet: '1fr 1fr', desktop: 'repeat(3,1fr)' }) }}>
            {HOME_ACTIVE_PLAYBOOKS.map((pb, i) => (
              <div key={i} style={{ padding: '12px 14px', borderRight: (!isMobile && i < HOME_ACTIVE_PLAYBOOKS.length - 1) ? '1px solid var(--border)' : undefined, borderBottom: (isMobile && i < HOME_ACTIVE_PLAYBOOKS.length - 1) ? '1px solid var(--border)' : undefined }}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--navy)', marginBottom: '3px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pb.title}</div>
                <div style={{ fontSize: '10px', color: 'var(--text3)', marginBottom: '7px' }}>{pb.contact} · {pb.org}</div>
                <div style={{ background: 'var(--surface)', borderRadius: '4px', height: '5px', marginBottom: '4px' }}>
                  <div style={{ width: `${pb.engagement}%`, height: '100%', background: pb.danger ? '#EF4444' : 'var(--gold)', borderRadius: '4px' }} />
                </div>
                <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{pb.engagement}% · {pb.views} views</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
